import { SxSViewState } from 'owa-sxsdata';

const entries: [HTMLElement, SxSViewState][] = [];

function removeEntry(element: HTMLElement) {
    if (element) {
        for (let i = 0; i < entries.length; i++) {
            const [currentEntryElement] = entries[i];
            if (currentEntryElement === element) {
                entries.splice(i, 1);
                break;
            }
        }
    }
}

export function registerSxSViewStateFromElement(
    oldElement: HTMLElement,
    element: HTMLElement,
    viewState: SxSViewState
): void {
    removeEntry(oldElement);
    removeEntry(element);

    if (element && viewState) {
        entries.push([element, viewState]);
    }
}

/**
 * A utility function to easily get the SxSViewState from an element inside SxSView
 * @param element an HTMLElement containing in SxSView
 * @returns the SxSViewState of the SxSView containing the element
 */
export default function getSxSViewStateFromElement(element: HTMLElement): SxSViewState {
    if (element) {
        for (let i = 0; i < entries.length; i++) {
            const [currentEntryElement, viewState] = entries[i];
            let currentElement = element;
            do {
                if (currentEntryElement === currentElement) {
                    return viewState;
                }

                currentElement = currentElement.parentElement;
            } while (currentElement);
        }
    }

    return null;
}
